import { Tooltip } from 'antd'
import React from 'react'
import { formatDateWithOrdinal } from '../../../../../../utils/commonFunction'
import {
  EventAnswer,
  EventCategory,
  EventDay,
  EventExpiry,
  EventHeading,
  EventStatusCard,
  EventText,
  EventTitle,
  EventTitleSection,
  StatusButton,
  VerticalLine,
} from './style'
import moment from 'moment'

const typeLabels = {
  OTHERS: 'Others',
  PRE_PLACEMENT_TALK: 'Pre Placement Talk',
  SEMINAR: 'Seminar',
  WEBINAR: 'Webinar',
  LECTURE: 'Lecture',
  CONFERENCE: 'Conference',
  PANEL_DISCUSSION: 'Panel Discussion',
  HACKATHON: 'Hackathon',
  WORKSHOP: 'Workshop',
  CAMPAIGN: 'Campaign',
  SPORTS_EVENT: 'Sports Event',
  ACTIVITY_EVENT: 'Activity Event',
  EXHIBITION: 'Exhibition',
}
export default function EventCard({
  variant,
  eventName,
  occurrence,
  allDayEvent,
  isRegister,
  location,
  categoryBasedObj,
  isApplied,
  handleClick,
  selectedData,
  data,
  endTime,
  startTime,
}) {
  let checkLength = allDayEvent ? 12 : 22
  const categoryStyles = {
    OTHERS: {
      borderColor: '#001B48',
      backgroundColor: 'rgba(0, 27, 72, 0.2)',
      textColor: 'White',
    },
    PRE_PLACEMENT_TALK: {
      borderColor: '#97CADB',
      backgroundColor: 'rgba(151, 202, 219, 0.2)',
      textColor: 'Black',
    },
    SEMINAR: {
      borderColor: '#B5A3F7',
      backgroundColor: 'rgba(181, 163, 247, 0.2)',
      textColor: 'Black',
    },
    WEBINAR: {
      borderColor: '#E1A7BA',
      backgroundColor: 'rgba(225, 167, 186, 0.2)',
      textColor: 'Black',
    },
    LECTURE: {
      borderColor: '#8D6AA0',
      backgroundColor: 'rgba(141, 106, 160, 0.2)',
      textColor: 'White',
    },
    CONFERENCE: {
      borderColor: '#F29F05',
      backgroundColor: 'rgba(242, 159, 5, 0.2)',
      textColor: 'Black',
    },
    PANEL_DISCUSSION: {
      borderColor: '#F25C05',
      backgroundColor: 'rgba(242, 92, 5, 0.2)',
      textColor: 'Black',
    },
    HACKATHON: {
      borderColor: '#31AAB5',
      backgroundColor: 'rgba(49, 170, 181, 0.2)',
      textColor: 'Black',
    },
    WORKSHOP: {
      borderColor: '#72B06F',
      backgroundColor: 'rgba(114, 176, 111, 0.2)',
      textColor: 'Black',
    },
    CAMPAIGN: {
      borderColor: '#4C1D91',
      backgroundColor: 'rgba(76, 29, 145, 0.2)',
      textColor: 'White',
    },
    SPORTS_EVENT: {
      borderColor: '#13593F',
      backgroundColor: 'rgba(19, 89, 63, 0.2)',
      textColor: 'White',
    },
    ACTIVITY_EVENT: {
      borderColor: '#02457A',
      backgroundColor: 'rgba(2, 69, 122, 0.2)',
      textColor: 'White',
    },
    EXHIBITION: {
      borderColor: '#595F33',
      backgroundColor: 'rgba(89, 95, 51, 0.2)',
      textColor: 'White',
    },
  }
  const categoryStyle = categoryStyles[selectedData?.category] || {
    borderColor: '#d8ddff',
    backgroundColor: 'white',
    textColor: 'black',
  }
  const formatTime = time => {
    let timeSplit

    if (moment.isMoment(time)) {
      timeSplit = time.format('HH:mm')
    } else if (typeof time === 'string' && time?.includes(':')) {
      timeSplit = time
    } else {
      console.error('Invalid time format')
      return ''
    }

    const [hour, minute] = (timeSplit?.split(':') || ['00', '00']);

    const hourNumber = parseInt(hour, 10)
    const period = hourNumber >= 12 ? 'PM' : 'AM'
    const formattedHour = hourNumber % 12 || 12
    return `${formattedHour}:${minute} ${period}`
  }

  return (
  
      <EventStatusCard
        borderColor={categoryStyle.borderColor}
        backgroundColor={categoryStyle.backgroundColor}
        color={categoryStyle.textColor}
        variant={variant}
        width="99%"
        mBottom={'8px'}
      >
        <EventText>
          <EventDay
            allDayEvent={allDayEvent}
            style={{ marginLeft: allDayEvent ? '0' : '-10px' }}
          >
            {allDayEvent ? 'All day' : `${formatTime(startTime)} - ${formatTime(endTime)}`}
          </EventDay>
          <VerticalLine show={true} borderColor={categoryStyle.borderColor} />
        </EventText>
        <EventTitleSection customWidth={'320px'}>
          <div
            style={{
              display: allDayEvent ? 'flex' : 'block',
              alignItems: 'center',
              gap: eventName?.length > 12 ? '0px' : '4px',
            }}
          >
            <Tooltip title={eventName}>
              <EventTitle
                ellipse={eventName?.length > 12}
                isWidth={checkLength > 20}
              >
                {eventName?.toLowerCase() ?? ''}
              </EventTitle>
            </Tooltip>
            {/* <EventCategory>{'(' + selectedData?.category + ')'}</EventCategory> */}
            <EventCategory>
  {'(' + (selectedData?.category ? typeLabels[selectedData?.category] : '') + ')'}
</EventCategory>

          </div>
          <VerticalLine show={true} borderColor={categoryStyle.borderColor} />
        </EventTitleSection>
        <EventTitleSection customWidth={'220px'}>
          {/* {occurrence && isApplied ? (
            <CompletedText>Registration completed!</CompletedText>
          ) : ( */}
            <div>
              <EventHeading>
                {isRegister && !isApplied ? 'Registration end date' : 'Event Dates'}
              </EventHeading>
              <EventAnswer>
              {
  isRegister && !isApplied
    ? formatDateWithOrdinal(new Date(selectedData.registerEndDate1))
    : selectedData.startDate1?.split('T')[0] === selectedData.endDate1?.split('T')[0]
    ? formatDateWithOrdinal(new Date(selectedData.startDate1), 'month')
    : `${formatDateWithOrdinal(new Date(selectedData.startDate1), 'month')}-${formatDateWithOrdinal(new Date(selectedData.endDate1), 'month')}`
}
              </EventAnswer>
            </div>
          {/* )} */}
          <VerticalLine show={location?.length > 0 ? true : false} borderColor={categoryStyle.borderColor} />
        </EventTitleSection>
        {location ? (
          <EventTitleSection customWidth={'220px'}>
            <div>
              <EventHeading>{'Event Location'}</EventHeading>
              <EventAnswer>{location?.toLowerCase()}</EventAnswer>
            </div>
            <VerticalLine
              show={false}
              borderColor={categoryStyle.borderColor}
            />
          </EventTitleSection>
        ) : null}
        {occurrence ? (
          <StatusButton
            text={
              isApplied && selectedData?.eventMode != 'OFFLINE'
                ? `  ${(selectedData?.category ?'Join ' + typeLabels[selectedData?.category]: '')}
                `
                : isRegister && !isApplied
                ? 'Register'
                : 'View Details'
            }
            status={
              isRegister && !isApplied
                ? 'register'
                : isApplied && selectedData?.eventMode != 'OFFLINE'
                ? 'register'
                : 'viewDetails'
            }
            onClick={handleClick}
          />
        ) : (
          <EventExpiry>{'Event lapsed'}</EventExpiry>
        )}
      </EventStatusCard>
   
  )
}